export const localStorageCheck = () => {
	let result: boolean = false;
	if (typeof window !== 'undefined') {
		if (window.localStorage) {
			result = true;
		}
	}
	return result;
};
